/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineBatchResponse {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineBatchResponse>): AIUnitEconomicsBaselineBatchResponse {
        let obj = Object.assign(new AIUnitEconomicsBaselineBatchResponse(), model);
        AIUnitEconomicsBaselineBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineBatchResponse>): AIUnitEconomicsBaselineBatchResponse {
        if (!model) return null;
        return AIUnitEconomicsBaselineBatchResponse.newInstance(<AIUnitEconomicsBaselineBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineBatchResponse) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineBatchResponse): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AIUnitEconomicsBaselineResponse.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AIUnitEconomicsBaselineResponse; };

}
